import script from "./translations.vue?vue&type=script&lang=ts&setup=true"
export * from "./translations.vue?vue&type=script&lang=ts&setup=true"

import "./translations.vue?vue&type=style&index=0&id=06996f97&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-06996f97"]])

export default __exports__